// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"427":"761be066","616":"3ed8e906","634":"aeed368c","645":"166d0896","937":"394b863c"}[chunkId] + ".chunk.css";
};